module.exports = __webpack_public_path__ + "media/images/email/facebook2x-eba00c67e9282612628d17efa3fddf10.png";